import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocationSearchToLocationPipe } from './location-search-to-location.pipe';

@NgModule({
  declarations: [LocationSearchToLocationPipe],
  imports: [CommonModule],
  exports: [LocationSearchToLocationPipe],
})
export class LocationSearchToLocationPipeModule {}
